import Sidebar from '@/components/common/Sidebar';
import Header from '@/components/Header';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

const DashboardLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="bg-primary">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />
      <div className="flex min-h-[calc(100vh-169px)]">
        <div className="xl:hidden">
          <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />
        </div>
        <main className="flex-1 overflow-hidden  111">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
